export default __webpack_public_path__ + "static/media/gnl10.cb2331b0.webp";